/** Alerts (Visitors Desk): flags on the long line and the wording of the Trends alerts card. */
import type { Annotation } from '../api/visitorsDesk'

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** One marker per day present in `days`: the rule label, or `{n} alerts` when a day has several. Days outside the series are dropped. */
export function markersFrom(annotations: Annotation[], days: string[]): { index: number; label: string }[] {
  const at = new Map(days.map((d, i) => [d, i]))
  const byIndex = new Map<number, string[]>()
  for (const a of annotations) {
    const i = at.get(a.day)
    if (i === undefined) continue
    byIndex.set(i, [...(byIndex.get(i) ?? []), a.label])
  }
  return [...byIndex.entries()].sort((x, y) => x[0] - y[0])
    .map(([index, labels]) => ({ index, label: labels.length > 1 ? `${labels.length} alerts` : labels[0] }))
}

export const ruleStateText = (enabled: boolean): 'On' | 'Off' => (enabled ? 'On' : 'Off')

/** `Last fired Oct 9`, or `Not fired yet`. Takes a date or a timestamp. */
export function lastFiredText(d: string | null | undefined): string {
  if (!d) return 'Not fired yet'
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d)
  if (!m) return 'Not fired yet'
  const name = MONTHS[Number(m[2]) - 1]
  return name ? `Last fired ${name} ${Number(m[3])}` : 'Not fired yet'
}
